/**
 * Onboarding module Zod schemas.
 * See docs/product/backend/m03-onboarding.md.
 */

import { z } from 'zod';
import { IndianPhoneSchema, UidSchema } from './common';

export const InviteRoleSchema = z.enum(['DEALER', 'DISTRIBUTOR', 'REVIEWER']);

export const InviteUserInputSchema = z
  .object({
    fullName: z.string().min(2).max(200),
    phoneNumber: IndianPhoneSchema.optional(),
    email: z.string().email().optional(),
    role: InviteRoleSchema,
    parentUid: UidSchema.optional(),
  })
  .refine((v) => v.phoneNumber || v.email, {
    message: 'phoneNumber or email required',
    path: ['phoneNumber'],
  });

export const BulkInviteRowSchema = InviteUserInputSchema;
export const BulkInviteBodySchema = z.object({
  rows: z.array(BulkInviteRowSchema).min(1).max(1000),
});

export const ReparentInputSchema = z.object({
  childUid: UidSchema,
  newParentUid: UidSchema,
});

export type InviteUserInput = z.infer<typeof InviteUserInputSchema>;
export type BulkInviteBody = z.infer<typeof BulkInviteBodySchema>;
export type ReparentInput = z.infer<typeof ReparentInputSchema>;
